import { $ } from '@3pc/dom';
export const $searchHeader = $('.search-header');
export const searchHeading = $searchHeader && $searchHeader.dataset.heading;
export const searchIntro =
  $searchHeader && $searchHeader.dataset.intro.replace(/\\n/g, '<br />');
export const $searchExperiments = $('.search-experiments');
export const queries =
  $searchExperiments &&
  JSON.parse($searchExperiments.dataset.queries.replaceAll('&quot;', '"'));
export const $search = $('#search-app');
export const labels = $search ? JSON.parse($search.dataset.labels) : {};
export const endpoints =
  $search && JSON.parse($search.dataset.endpoints.replaceAll('&quot;', '"'));
export const searchType = $search && $search.dataset.searchType;
